export default "__VITE_ASSET__BXB2X6oZ__"